<template>
  <v-data-table
    :headers="headers"
    :items="records"
    item-key="nomenklatura_id"
    hide-actions
  >
    <template slot="items" slot-scope="props">
      <tr>
        <td class="text-xs-right">{{ props.item.nomenklatura_id }}</td>
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.kolichestvo }}</td>
        <td class="text-xs-right">{{ props.item.tsena }}</td>
        <td class="text-xs-right">{{ props.item.summa }}</td>
      </tr>
    </template>
    <template slot="footer">
      <td colspan="100%" class="text-xs-right">
        Итого: <strong>{{ summa }}</strong>
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'RashodnayaNakladnayaTable',
  props: {
    records: {
      default: () => [],
      required: true,
      type: Array
    },
    summa: {
      required: true
    }
  },
  data () {
    return {
      headers: [
        {
          text: 'Код',
          align: 'right',
          width: '100px',
          value: 'nomenklatura_id'
        },
        {
          text: 'Товар',
          align: 'left',
          value: 'name'
        },
        {
          text: 'К-во',
          align: 'right',
          width: '100px',
          value: 'kolichestvo'
        },
        {
          text: 'Цена',
          width: '120px',
          align: 'right',
          value: 'tsena'
        },
        {
          text: 'Сумма',
          width: '120px',
          align: 'right',
          value: 'summa'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
